import ClientService from '../../../services/client-service';
import getUserListDataQuery from '../../../graphql/query/get-user-list-data.graphql';
import getUserEmailContactDataQuery from '../../../graphql/query/get-user-email-contact-data.graphql';
import saveUserListDataMutation from '../../../graphql/mutation/save-user-list-data.graphql';
import inviteUserMutation from '../../../graphql/mutation/invite-user.graphql';
import deactivateUserMutation from '../../../graphql/mutation/deactivate-user.graphql';
import resetUserPasswordMutation from '../../../graphql/mutation/reset-user-password.graphql';
import deleteUserMutation from '../../../graphql/mutation/delete-user.graphql';

export default class SettingsUserListApi {
  public static getUserListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getUserListDataQuery, payload);
  }

  public static saveUserListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveUserListDataMutation, payload);
  }

  public static inviteUser(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(inviteUserMutation, payload);
  }

  public static deactivateUser(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deactivateUserMutation, payload);
  }

  public static resetUserPassword(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(resetUserPasswordMutation, payload);
  }

  public static getUserEmailContactData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getUserEmailContactDataQuery, payload);
  }

  public static deleteUser(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(deleteUserMutation, payload);
  }
}
